import type {
  AddGamePlayerType,
  AddPlayers
} from '@library/types/boardBuilder';
import { useCallback, useMemo, useState } from 'react';
import { difference } from 'ramda';

export const useBoardBuilderPlayers = () => {
  const [confirmedPlayersList, setConfirmedPlayersList] = useState<AddPlayers>(
    []
  );
  const [selectedPlayersList, setSelectedPlayersList] = useState<AddPlayers>(
    []
  );

  const unSelectedPlayersList = useMemo(
    () => difference(confirmedPlayersList, selectedPlayersList),
    [confirmedPlayersList, selectedPlayersList]
  );

  const newlySelectedPlayersList = useMemo(
    () => difference(selectedPlayersList, confirmedPlayersList),
    [confirmedPlayersList, selectedPlayersList]
  );

  const handleCancelSelectedPlayersList = () => {
    setSelectedPlayersList(confirmedPlayersList);
  };

  const handleConfirmSelectedPlayersList = () => {
    setConfirmedPlayersList(selectedPlayersList);
  };

  const handleSelectPlayer = ({ game, player }: AddGamePlayerType) => {
    setSelectedPlayersList([...selectedPlayersList, { game, player }]);
  };

  const handleUnSelectPlayer = ({ game, player }: AddGamePlayerType) => {
    const modifiedPlayerList = selectedPlayersList.filter(
      (gamePlayer) =>
        gamePlayer.game.game_id !== game.game_id ||
        gamePlayer.player.foreign_id !== player.foreign_id
    );

    setSelectedPlayersList(modifiedPlayerList);
  };
  const handleResetPlayers = useCallback(() => {
    setSelectedPlayersList([]);
    setConfirmedPlayersList([]);
  }, []);

  return {
    confirmedPlayersList,
    newlySelectedPlayersList,
    handleCancelSelectedPlayersList,
    handleConfirmSelectedPlayersList,
    handleResetPlayers,
    handleSelectPlayer,
    handleUnSelectPlayer,
    selectedPlayersList,
    unSelectedPlayersList
  };
};
